import usePrivateAxios from '@/common/api/usePrivateAxios'
import {
  ContractEnvelopeData,
  ContractEnvelopeResponse,
} from '@/features/privateCompanyLeadsFunnel/types/privateCompanyLeadContractEnvelope'
import { useQuery } from '@tanstack/react-query'
import { useState } from 'react'

interface UsePrivateCompanyLeadContractEnvelopeProps {
  privateCompanyLeadId: string
}

export const usePrivateCompanyLeadContractEnvelope = ({
  privateCompanyLeadId,
}: UsePrivateCompanyLeadContractEnvelopeProps) => {
  const privateAxios = usePrivateAxios()

  const [stillSyncing, setStillSyncing] = useState(false)

  return useQuery<ContractEnvelopeResponse, unknown, ContractEnvelopeData>({
    queryKey: ['privateCompanyLeadContractEnvelope', privateCompanyLeadId],
    queryFn: () => {
      return privateAxios.get(`/funnel/private_company_leads/${privateCompanyLeadId}/contract_envelope`)
    },
    refetchInterval: stillSyncing ? 5000 : false,
    select: (data) => {
      const refetch = ['syncing', 'awaiting_signatures'].includes(data?.data?.data?.status)

      refetch !== stillSyncing && setStillSyncing(refetch)

      return data?.data?.data
    },
  })
}
